import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useEffect, useRef } from "react";
import { useCurrentResultRealIndex } from "~/components/AssetModalV2/Content/Panel/Transcript/hooks/useCurrentResultRealIndex";
import { TranscriptSearch } from "~/components/AssetModalV2/Content/Panel/Transcript/TranscriptSearch";
import { useTranscriptScrollInfoContext } from "~/providers/TranscriptScrollInfoProvider";
import { useTranscriptSearchResultsContext } from "~/providers/TranscriptSearchResultsProvider";
import { useVideoControlContext } from "~/providers/VideoControlsProvider";
export const TranscriptSearchWrapper = /*#__PURE__*/ memo((param)=>{
    let { onSearch, results, isLoading, onCurrentIndexChange } = param;
    const { setSearchResults, getSearchResults, setSearchText } = useTranscriptSearchResultsContext();
    const { pause } = useVideoControlContext();
    const { setCurrentTime } = useVideoControlContext();
    const { setScrollEnabled } = useTranscriptScrollInfoContext();
    const onCurrentIndexChangeRef = useRef(onCurrentIndexChange);
    onCurrentIndexChangeRef.current = onCurrentIndexChange;
    const onCurrentResultChange = useCallback((index)=>{
        const result = results === null || results === void 0 ? void 0 : results.data[index];
        setScrollEnabled(true);
        // Setting video to current word time - it will automatically scroll to the current segment
        result && result.type === "result" && setCurrentTime(result.startTimeMs / 1000);
        onCurrentIndexChangeRef.current(index);
    }, [
        results === null || results === void 0 ? void 0 : results.data,
        setCurrentTime,
        setScrollEnabled
    ]);
    const { recalculateCurrentRealIndex, onGoToPrevResult, onGoToNextResult, resetCurrentRealIndex, currentRealIndexRef, goToFirstResult } = useCurrentResultRealIndex({
        onCurrentResultChange
    });
    const _onSearch = useCallback((value)=>{
        if (value.length === 0) {
            setSearchResults([]);
            resetCurrentRealIndex();
        }
        setSearchText(value);
        onSearch(value);
    }, [
        onSearch,
        resetCurrentRealIndex,
        setSearchResults,
        setSearchText
    ]);
    useEffect(()=>{
        if (!results) {
            return;
        }
        recalculateCurrentRealIndex(results.data);
        setSearchResults(results.data);
        if (!(results === null || results === void 0 ? void 0 : results.total)) {
            resetCurrentRealIndex();
        } else {
            const firstResult = results.data[0];
            if ((firstResult === null || firstResult === void 0 ? void 0 : firstResult.type) === "result" && currentRealIndexRef.current === -1) {
                goToFirstResult();
            }
        }
    }, [
        currentRealIndexRef,
        getSearchResults,
        goToFirstResult,
        onCurrentResultChange,
        onGoToNextResult,
        pause,
        recalculateCurrentRealIndex,
        resetCurrentRealIndex,
        results,
        setSearchResults
    ]);
    var _results_total;
    return /*#__PURE__*/ _jsx(TranscriptSearch, {
        totalResults: (_results_total = results === null || results === void 0 ? void 0 : results.total) !== null && _results_total !== void 0 ? _results_total : 0,
        isLoading: isLoading,
        onSearch: _onSearch,
        onGoToNextResult: onGoToNextResult,
        onGoToPrevResult: onGoToPrevResult
    });
});
TranscriptSearchWrapper.displayName = "TranscriptSearchWrapper";
